export const UPDATE_COLLECTIONS = "UPDATE_COLLECTIONS";
export const FETCH_COLLECTIONS_START = "FETCH_COLLECTIONS_START";
export const FETCH_COLLECTIONS_SUCCESS = "FETCH_COLLECTIONS_SUCCESS";
export const FETCH_COLLECTIONS_FAIL = "FETCH_COLLECTIONS_FAIL";
